import { type Country } from '@backmarket/http-api'

import { STATES } from '../../constants'
import { type State } from '../../types'

export function getAllStates(country: Country): State[] {
  return STATES[country] || []
}
